import React from 'react';
import { Button } from '../../../../components/buttons';

const gudangCard = (props) => {
    return (
        <div className="px-5 mb-2">
            <div className="row d-flex justify-content-between">
                <h4>
                    Gudang.io
                </h4>
                
                {
                    props.token  ? 
                        <div>
                            {
                                props.token.status === 'notActive' ? 
                                    <div className="pr-4 p-1 float-right d-flex">
                                        <div className="pt-2 pr-4">🛑 <b>Kunci Belum Aktif</b></div>
                                        <Button
                                            onClick={() => props.onOpenQR(props.token.id)}
                                            className="btn btn-outline-primary btn-sm mr-2"
                                            loading={props.loadingExtendKey}
                                        >
                                            Aktivasi
                                        </Button>
                                        <button
                                            onClick={() => props.onDeleteToken(props.token.id)}
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            Putuskan
                                        </button>
                                    </div>
                                    :
                                    <div>
                                        <div className="pr-4 p-1 float-right d-flex align-items-center">
                                            <div className="pr-4">
                                                <div>✅ <b>Kunci Sudah Dibuat</b></div>
                                            </div>
                                                        
                                            <button
                                                onClick={() => props.onDeleteToken(props.token.id)}
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                Putuskan
                                            </button>
                                        </div>
                                    </div>
                            }
                        </div> 
                        :
                        <div className="input-group-sm col-2">
                            <button 
                                onClick={props.onClickActivate}
                                type="submit" 
                                class="btn btn-sm btn-primary"
                            >
                                Aktifkan 
                            </button>
                        </div>
                }
                
            </div>
        </div>
    )
}

export default gudangCard;